import LotepImage from '@/assets/images/lotepLogoWhite.png';
import { type WhitelabelConfig } from '@/brands/types';
import { Colors } from '@/brands/wep/colors';
import luckyWheelBackground from '@/brands/wep/images/backgroundLuckyWheel.jpeg';
import luckyWheelBackgroundDesktop from '@/brands/wep/images/backgroundLuckyWheelDesk.jpeg';
import logoWep from '@/brands/wep/images/wep-branco.png';
import logoWheel from '@/brands/wep/images/wepCenter.png';

import type { Metadata } from 'next';

export const wePremiosMetaData: Metadata = {
  title: 'WePrêmios',
  description: 'Plataforma de apostas',
  metadataBase: new URL('https://wepremios.com'),
  openGraph: {
    title: 'WePrêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    url: 'https://wepremios.com',
    siteName: 'WePrêmios',
    images: [
      {
        url: '/images/WePremiosLogo.png',
        width: 1200,
        height: 630,
        alt: 'WePrêmios',
      },
    ],
    locale: 'pt_BR',
    type: 'website',
  },
  icons: {
    icon: '/favicon/favicon.png',
    apple: '/favicon/favicon.png',
  },
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
  twitter: {
    card: 'summary_large_image',
    title: 'WePrêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    images: ['/images/WePremiosLogo.png'],
  },
};

export const wepConfig: WhitelabelConfig = {
  name: 'wep',
  displayName: 'We Prêmios',
  assets: {
    logo: logoWep.src,
    logoHeader: logoWep.src,
    logoMenu: logoWep.src,
    logoWheel: logoWheel.src,
    luckyWheelBackground: luckyWheelBackground.src,
    luckyWheelBackgroundDesktop: luckyWheelBackgroundDesktop.src,
  },
  capitalizer: {
    link: 'https://lotep.pb.gov.br/',
    displayName: 'LOTEP - Loteria do Estado da Paraíba',
    logoFooter: LotepImage.src,
  },
  colors: Colors,
  meta: {
    description: 'We Prêmios',
    baseUrl: 'https://wepremios.com',
    ogImage: '/images/WePremiosLogo.png',
    favicon: '/favicon/favicon.png',
    appleIcon: '/favicon/favicon.png',
  },
};
